/**
 * 页面标题到国际化键的映射表
 * 用于统一管理所有页面标题的国际化配置
 */
export const TITLE_I18N_MAP: Record<string, string> = {
  // 主要导航页面
  '首页': 'common.menu.home',
  '仪表盘': 'common.menu.dashboard',
  '委托下单': 'common.menu.entrustedOrder',
  '控制塔面板': 'common.menu.controlTowerPanel',
  'BI统计分析': 'biAnalytics.pages.biAnalyticsPage',

  // 运价相关
  '超级运价': 'common.menu.superRates',
  '运价维护': 'common.menu.rateManagement',
  '整箱运价管理': 'common.menu.fclRates',
  '合约管理': 'common.menu.contractManagement',
  '订舱申请': 'orders.booking.title',
  '新增合约': 'saas.contracts.add.title',
  '编辑合约': 'saas.contracts.edit.title',
  '附加费管理': 'common.menu.surchargeManagement',
  '附加费维护': 'common.menu.surchargeManagement',
  '加价规则管理': 'common.menu.pricingRuleManagement',
  '加价规则维护': 'common.menu.markupRuleMaintenance',
  '商务加价规则': 'common.menu.businessMarkupRules',
  '销售加价规则维护': 'common.menu.salesMarkupRuleMaintenance',
  '报价记录': 'common.menu.salesQuotation',
  '运价查询': 'common.menu.rateQuery',

  // 运价管理（经营运价）
  '运价管理': 'common.menu.managementFreight',
  '运价库': 'common.menu.rateWarehouse',
  '运价库海运整箱': 'common.menu.rateWarehouseFcl',
  '运价库海运拼箱': 'common.menu.rateWarehouseLcl',
  '招投标管理': 'common.menu.biddingManagement',
  '招标管理': 'common.menu.tenderManagement',
  '投标管理': 'common.menu.bidManagement',

  // 船司电商运价（含 CCTOWER-2296 船司账号维护）
  '船司电商运价': 'common.menu.ecommerceCarrierRates',
  '电商运价': 'common.menu.ecommerceRates',
  '运价监控': 'common.menu.ecommercePriceWatch',
  // '船司账号维护': 'common.menu.ecommercePlatformAccount',
  '今日运价': 'common.menu.ecommerceDailyRates',
  '每日推送配置': 'common.menu.ecommerceSubscription',

  // 询报价管理
  '询价报价': 'common.menu.inquiryQuotation',
  '询价管理': 'common.menu.inquiryManagement',
  '报价管理': 'common.menu.quoteManagement',

  // 向供应商询价单（custom-quotation-v2 邮件链接表单）
  '海运询价单': 'quotation.supplierFclQuotation.inquiryTitle',
  '空运询价单': 'quotation.supplierAirQuotation.inquiryTitle',
  '铁路询价单': 'quotation.supplierRailQuotation.inquiryTitle',
  '港前询价单': 'quotation.supplierPrePortQuotation.inquiryTitle',
  '尾程询价单': 'quotation.supplierLastMileQuotation.inquiryTitle',

  // 舱位相关
  '舱位查询': 'common.menu.spaceQuery',
  '舱位预订': 'common.menu.spaceBooking',
  '舱位统计': 'common.menu.spaceStatistics',

  // 订单中心
  '订单中心': 'common.menu.orders',
  '订单管理': 'common.menu.orderManagement',
  '状态追踪': 'common.menu.orderTracking',
  '发货申请单': 'common.menu.distributionShipment',
  '运输计划单': 'transportPlan.title',
  '运输委托单': 'transportConsignment.title',
  '运单': 'waybill.title',
  '运单详情': 'waybill.detail.title',
  '运输计划详情': 'transportPlan.pageTitles.detail',
  '编辑运输计划单': 'transportPlan.pageTitles.edit',

  // 结算
  '结算': 'common.menu.settlement',
  '结算账单': 'common.menu.settlementStatement',

  // 客商中心
  '客户中心': 'common.menu.customer',
  '客商中心': 'common.menu.customer',
  '用户管理': 'common.menu.userManagement',
  '企业管理': 'common.menu.companyManagement',
  '添加企业': 'common.menu.companyManagement',
  '编辑企业': 'common.menu.companyManagement',
  '角色权限管理': 'common.menu.roleAuthManagement',

  // 用户中心
  '用户中心': 'common.menu.userCenter',
  '个人信息': 'common.menu.userProfile',
  '企业信息': 'common.menu.companyProfile',

  // 计费管理
  '计费管理': 'common.menu.billingManagement',

  // 应用中心
  '应用中心': 'common.menu.application',
  'API中心': 'common.menu.apiCenter',
  'API列表': 'common.menu.apiList',
  'API设置': 'common.menu.apiSettings',

  // 系统设置
  '系统设置': 'common.menu.systemSettings',
  '角色管理': 'common.menu.roleManagement',
  '员工管理': 'common.menu.staffManagement',
  '权限管理': 'common.menu.permissionManagement',
  '部门管理': 'common.menu.departmentManagement',
  '岗位管理': 'common.menu.postManagement',

  // 基础资料维护
  '基础资料维护': 'common.menu.basicData',
  '港口管理': 'common.menu.portManagement',
  '承运人管理': 'common.menu.carrierManagement',
  '国家（地区）': 'common.menu.countryRegionManagement',
  '中国行政区划': 'common.menu.chinaAdministrativeDivision',
  '海外仓库': 'common.menu.overseasWarehouseManagement',
  '仓库管理': 'common.menu.overseasWarehouseManagement',
  '邮编管理': 'common.menu.zipcodeManagement',
  '航线管理': 'common.menu.routeManagement',
  '集装箱管理': 'common.menu.containerManagement',
  '包装单位': 'common.menu.packageUnitManagement',
  '运输条款': 'common.menu.transportTermsManagement',
  '贸易条款': 'common.menu.tradeTermsManagement',
  '币种管理': 'common.menu.currencyManagement',
  '汇率设置': 'common.menu.exchangeRateManagement',
  '计费单位': 'common.menu.calculationUnitManagement',
  '费用管理': 'common.menu.chargeManagement',
  '船舶代理': 'common.menu.shipAgentManagement',
  '码头管理': 'common.menu.terminalManagement',
  '产品物料数据': 'common.menu.productMaterialData',
  '供应商合同管理': 'supplierContract.list.title',
  '供应商合同详情': 'supplierContract.detail.title',
  '船舶资料': 'common.menu.shipData',
  '船舶数据管理': 'common.menu.shipDataManagement',

  // 船舶调度中心
  '船期中心': 'common.menu.shippingScheduleCenter',
  '船舶调度中心': 'common.menu.shippingScheduleCenter',
  '航线维护': 'common.menu.lineMaintenance',
  '船期查询': 'common.menu.shipSchedule',
  '船舶调度': 'common.menu.shipSchedule',

  // 个性化配置
  '个性化配置': 'common.menu.personalizationConfig',
  '公司新闻': 'common.menu.companyNews',
  '模板配置': 'common.menu.templateConfig',
  '模板设置': 'common.menu.templateConfig',
  '任务管理': 'common.menu.taskManagement',
  '文字运价AI导入详情': 'taskManagement.detail.textRateImportTaskDetailTitle',
  '文字运价解析预览': 'saas.rateManagement.fcl.textRatePreview.breadcrumb.preview',
  '流程管理': 'common.menu.approvalProcess',
  '新建流程': 'approvalProcess.editor.createTitle',
  '编辑流程': 'approvalProcess.editor.editTitle',
  '节点管理': 'common.menu.nodeManagement',
  '业务经理配置': 'common.menu.businessManagerConfig',
  '业务负责人设置': 'common.menu.businessManagerConfig',
  '供应商报价配置': 'common.menu.supplierQuotationConfig',

  // 开发组件示例
  '组件示例': 'common.menu.componentsDemo',
  '示例页面': 'common.menu.examplePage',
  '高级选择组件': 'common.menu.advancedSelectExample',
  '筛选方案管理': 'common.menu.filterManagement',
  '权限使用说明': 'common.menu.permissionUsage',
  '销售报价详情': 'saas.rateQuery.salesQuotation.linkDetail.pageTitle'
}

/**
 * 获取标题对应的国际化键
 * @param title - 页面标题
 * @returns 国际化键，如果没有找到则返回原标题
 */
export const getTitleI18nKey = (title: string): string => {
  return TITLE_I18N_MAP[title] || title
}
